//
// Homepage functions
//

export default class Homepage {
  constructor() {

    // Check that the homepage header element exists
    const homepageHeaderElement = document.querySelector("#js-home-header");
    if (!homepageHeaderElement) return;

    // Create an observer for the homepage header area
    const quickNavButtons = document.querySelector('#js-quick-nav-buttons');

    const homepageHeaderObserverOptions = {
      threshold: 0.5,
    }

    var homepageHeaderObserver = new IntersectionObserver(entries => {
      if (!entries[0].isIntersecting) {
        quickNavButtons.classList.add('quick-nav-button-wrap--show');
      } else {
        quickNavButtons.classList.remove('quick-nav-button-wrap--show');
      }
    }, homepageHeaderObserverOptions);

    homepageHeaderObserver.observe(homepageHeaderElement);

  }
}